<app-banner></app-banner> 
<app-products [products] ="items"></app-products>

